import React from 'react';
import { InboxMockup } from './InboxMockup';
export function Hero() {
  return <section className="min-h-screen flex items-center pt-28 pb-20 px-6 md:px-12 lg:px-24 bg-[#fffefc]" data-id="element-55">
      <div className="max-w-7xl mx-auto w-full" data-id="element-56">
        <div className="text-center mb-12" data-id="element-57">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-[#2D1810] leading-tight mb-4" data-id="element-58">
            Turning inbox chaos into calm.
          </h1>
          <p className="text-lg md:text-xl text-[#6B5244] max-w-3xl mx-auto" data-id="element-59">
            Lighten your mental load, focus on what matters, and leave the
            busywork behind.
          </p>
        </div>
        <div className="max-w-2xl mx-auto" data-id="element-60">
          <InboxMockup data-id="element-61" />
        </div>
      </div>
    </section>;
}